/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  PaymentMethod,
// @ts-ignore
  PaymentMethodListResponse,
// @ts-ignore
  PaymentMethodSetupResponse,
// @ts-ignore
  PaymentProviderStatusResponse,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    PaymentMethodFromJSON,
// @ts-ignore
    PaymentMethodToJSON,
// @ts-ignore
    PaymentMethodListResponseFromJSON,
// @ts-ignore
    PaymentMethodListResponseToJSON,
// @ts-ignore
    PaymentMethodSetupResponseFromJSON,
// @ts-ignore
    PaymentMethodSetupResponseToJSON,
// @ts-ignore
    PaymentProviderStatusResponseFromJSON,
// @ts-ignore
    PaymentProviderStatusResponseToJSON,
} from '../models/index';

export interface DeletePaymentMethodRequest {
    id: string;
}

export interface DisablePaymentMethodRequest {
    id: string;
}

export interface EnablePaymentMethodRequest {
    id: string;
}

export interface SetDefaultPaymentMethodRequest {
    id: string;
}

/**
 * 
 */
export class PaymentsApi extends runtime.BaseAPI {

    /**
     * Create a payment method setup for the current user
     */
    async createPaymentMethodSetupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethodSetupResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/setup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodSetupResponseFromJSON(jsonValue));
    }

    /**
     * Create a payment method setup for the current user
     */
    async createPaymentMethodSetup(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethodSetupResponse> {
        const response = await this.createPaymentMethodSetupRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete payment method
     */
    async deletePaymentMethodRaw(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete payment method
     */
    async deletePaymentMethod(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Disable payment method
     */
    async disablePaymentMethodRaw(requestParameters: DisablePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disablePaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disable payment method
     */
    async disablePaymentMethod(requestParameters: DisablePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disablePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Enable payment method
     */
    async enablePaymentMethodRaw(requestParameters: EnablePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enablePaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enable payment method
     */
    async enablePaymentMethod(requestParameters: EnablePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enablePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Get default payment method
     */
    async getDefaultPaymentMethodRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethod>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/default`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodFromJSON(jsonValue));
    }

    /**
     * Get default payment method
     */
    async getDefaultPaymentMethod(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethod> {
        const response = await this.getDefaultPaymentMethodRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get payment provider status
     */
    async getPaymentProviderStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentProviderStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payments/provider/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentProviderStatusResponseFromJSON(jsonValue));
    }

    /**
     * Get payment provider status
     */
    async getPaymentProviderStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentProviderStatusResponse> {
        const response = await this.getPaymentProviderStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * List payment methods for the current user
     */
    async listPaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethodListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodListResponseFromJSON(jsonValue));
    }

    /**
     * List payment methods for the current user
     */
    async listPaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethodListResponse> {
        const response = await this.listPaymentMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set default payment method
     */
    async setDefaultPaymentMethodRaw(requestParameters: SetDefaultPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setDefaultPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/{id}/default`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set default payment method
     */
    async setDefaultPaymentMethod(requestParameters: SetDefaultPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultPaymentMethodRaw(requestParameters, initOverrides);
    }

}
